export default "__VITE_ASSET__CvsEw3Fw__"